import * as React from 'react';
import {connect} from 'react-redux';
import moment from "moment";
import {addBOInstanceTags, deleteBOInstanceTags, deleteInstances} from '../../../actions/boCoreActions';
import * as toastr from "toastr";
import AgGridTagsQtip from '../common/AgGridTagsQtip';
import * as agGrid from "ag-grid-community/main";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import {BusinessObjectBaseInterface} from "../Interfaces/BusinessObjectBaseInterface";
import {Instance} from "../models/Instance";
import {AttributeTypeEnum} from "../enums/AttributeTypeEnum";
import AgSelectAllHeader from "../common/AgSelectAllHeader";
import AgGridFooter from "../common/AgGridFooter";
import AgHelpToolTip, {helpHeaderTemplate} from "../common/AgHeaderHelpToolTip";
import GlobalSearchHelpToolTip from "../common/GlobalSearchHelpToolTip";
import Utils from "../../../Utils";
import Axios from "../../../config/Axios";
import history from "../../../config/history";
import AgGridUtils from "../../../AgGridUtils";

interface Props {
    tagsSet: any;
    currentDataView: any
    currentBusinessObject: BusinessObjectBaseInterface
    title: any;

    deleteInstances(ids: number[], onSuccessCallback: any);

    addBOInstanceTags(currentInstance: any, originalInstance: any, tags: any);

    deleteBOInstanceTags(currentInstance: any, originalInstance: any, tags: any);
}

interface State {
    grid: any;
}

class GlobalSearchGrid extends React.Component<Props, State> {
    private timeout: any = 0;
    private _isMounted: boolean = false;

    constructor(props: Props) {
        super(props);
        this.state = {
            grid: null
        }
    }

    componentDidMount() {
        $(this.refs.quickFilterBox).focus();
        this._isMounted = true;
        this.buildGrid();
        document.addEventListener('keydown', this.keydownHandler);
    }

    componentWillUnmount(): void {
        this._isMounted = false;
        this.state.grid.gridOptions.api.destroy();
        document.removeEventListener('keydown', this.keydownHandler);
        $("#hide-nav-btn").off();
    }

    onDeleteHandler = () => {
        const ids = this.state.grid.gridOptions.api.getSelectedRows().map(item => item.id);
        Utils.$('#delete-btn').blur();
        if (ids.length > 0) {
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                content: `You are about to delete ${ids.length} instances, this procedure is irreversible.`,
                type: 'red',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            this.props.deleteInstances(ids, () => {
                                this.state.grid.gridOptions.api.deselectAll();
                                this.onFilterTextBoxChanged({type: "click"});
                            });
                        }
                    },
                    cancel: () => {
                    }
                }
            });
        }
    };

    keydownHandler = (e) => {
        if(e.ctrlKey && e.altKey && e.keyCode === 68) {
            Utils.$('#delete-btn').click();
        }
        if(e.shiftKey && e.keyCode === 38) {
            e.preventDefault();
            $(this.refs.quickFilterBox).focus();
        }
        if (e.shiftKey && e.keyCode === 40) {
            e.preventDefault();
            Utils.$('.ag-floating-filter-input')[0].focus();
        }
        if (e.keyCode === 9) {
            const element = document.activeElement;
            const id = element.id.split('-')[3];

            if (element.classList.contains("ag-floating-filter-input")) {
                if (Utils.$('.ag-floating-filter-input').length - 1 === Number.parseInt(id)) {
                    this.setGridFistCellOnFocus(e);
                }
            }
        }
    };

    saveGridState = () => {
        window['sortState'] = this.state.grid.gridOptions.api.getSortModel();
        window['filterState'] = this.state.grid.gridOptions.api.getFilterModel();
    };

    setGridFistCellOnFocus = (event) => {
        if (event.keyCode === 9) {
            event.preventDefault();

            // scrolls to the first row
            this.state.grid.gridOptions.api.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.grid.gridOptions.columnApi.getAllDisplayedColumns()[0];
            this.state.grid.gridOptions.api.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.grid.gridOptions.api.setFocusedCell(0, currentCol);
        }
    };

    onFilterTextBoxChanged = (e) => {
        if (e.ctrlKey && e.altKey) {
            e.preventDefault();
        }
        if ((e.type === "keydown" && e.keyCode === 13) || e.type === "click") {
            this.state.grid.gridOptions.api.setFilterModel({
                quickFilter: {
                    filterType: "text",
                    type: "contains",
                    filter: $(this.refs.quickFilterBox).val()
                }
            });
        }
        this.setGridFistCellOnFocus(e);
    };


    buildGrid = () => {
        const columnDef: any = [
            {
                field: "quickFilter", hide: true, lockVisible: true,
                filterParams: {
                    newRowsAction: "keep"
                },
                dataType: AttributeTypeEnum.TEXT
            },
            {
                headerName: "ID", width: 50, field: "id", checkboxSelection: true,
                dataType: AttributeTypeEnum.INT,
                cellRenderer: function (params) {
                    return `<label style="cursor: pointer; color:#5baeff">${params.value}</label>`
                },
                headerComponent: AgSelectAllHeader,
                headerTooltip: "ID"
            },
            {
                headerName: "Type", width: 50, field: "type",
                dataType: AttributeTypeEnum.TEXT,
                cellRenderer: function (params) {
                    return `<label style="cursor: pointer; color:#5baeff">${params.value.name}</label>`
                },
                headerTooltip: "Type"
            },
            {
                headerName: "Name", width: 50, field: "name",
                dataType: AttributeTypeEnum.TEXT,
                headerTooltip: "Name"
            },
            {
                headerName: "Tags",
                field: 'tags',
                width: 50,
                cellRenderer: "tagCellRender",
                dataType: AttributeTypeEnum.TAGS,
                headerTooltip: "Tags"
            },
            {
                headerName: "Updated", width: 50, field: "updated",
                dataType: AttributeTypeEnum.TIMESTAMP,
                headerTooltip: "Updated"
            }
        ];


        function TagCellRender() {
        }

        TagCellRender.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            const $div = $("<div/>");
            const $content = $('<div style="display: -webkit-box"/>');
            const tags = params.value ? params.value : [];
            $(`<button class='btn slick-grid-tags manage-data-qtip-tags'>...</button>`).appendTo($content);
            for (let i = 0; i < Math.min(4, tags.length); i++) {
                $(`<div class="slick-grid-tags" >${tags[i]}</div>`).appendTo($content);
            }
            $content.appendTo($div);
            this.eGui.innerHTML = $div.html();
        };

        TagCellRender.prototype.getGui = function () {
            return this.eGui;
        };

        const gridOptions: any = {
            defaultColDef: {
                resizable: true,
                sortable: true,
                suppressDragLeaveHidesColumns: true,
                filter: "agTextColumnFilter",
                filterParams: {
                    filterOptions: ['contains'],
                    applyButton: true,
                    clearButton: true,
                    suppressAndOrCondition: true
                },
                tooltipComponent: AgHelpToolTip,
                headerComponentParams: {
                    template: helpHeaderTemplate
                },
                floatingFilterComponentParams: {suppressFilterButton: true},
                menuTabs: ['generalMenuTab']
            },
            components: {
                'tagCellRender': TagCellRender
            },
            cacheQuickFilter: this.refs.quickFilterBox,
            onCellClicked: (params) => {
                if ($(params.event.target).hasClass("manage-data-qtip-tags")) {
                    const item = params.data;
                    AgGridTagsQtip({
                        item,
                        gridOptions,
                        target: params.event.target,
                        rowNode: params.node,
                        viewportId: "ManageDataGrid",
                        tagsList: Array.from(this.props.tagsSet),
                        saveTags: (oldTags, tagsForSave) => {
                            const currentInstance = new Instance(item.id, item.name, {
                                id: null,
                                name: null,
                                description: null
                            }, [], [], item.tags, "", moment.utc(item.updated).utcOffset(moment(item.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), "");

                            const originalInstance = new Instance(item.id, item.name, {
                                id: null,
                                name: null,
                                description: null
                            }, [], [], oldTags, "", moment.utc(item.updated).utcOffset(moment(item.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), "");

                            this.props.addBOInstanceTags(currentInstance, originalInstance, tagsForSave);
                        },
                        deleteTags: (oldTags, tagsForDelete) => {
                            const currentInstance = new Instance(item.id, item.name, {
                                id: null,
                                name: null,
                                description: null
                            }, [], [], item.tags, "", moment.utc(item.updated).utcOffset(moment(item.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), "");

                            const originalInstance = new Instance(item.id, item.name, {
                                id: null,
                                name: null,
                                description: null
                            }, [], [], oldTags, "", moment.utc(item.updated).utcOffset(moment(item.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), "");

                            this.props.deleteBOInstanceTags(currentInstance, originalInstance, tagsForDelete);
                        },
                    });
                } else if (params.column.colId === "id") {
                    this.saveGridState();
                    localStorage.setItem('cameFromGlobalSearch', 'cameFromGlobalSearch');
                    history.push(`${process.env.ENV_PREFIX}/instance/${params.value}`);
                } else if (params.column.colId === "type") {
                    history.push(`${process.env.ENV_PREFIX}/managedata?boc=${params.value.name.toLowerCase()}`);
                }
            },
            onGridReady: (params: any) => {
                params.api.sizeColumnsToFit();
            },
            onRowSelected: (params: any) => {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    if (this._isMounted) {
                        this.state.grid.gridOptions.selectAllHeader.onRowSelected(params);
                        this.forceUpdate();
                    }
                }, 1);
            },
            onFilterChanged: () => {AgGridUtils.deselectAllRows(this.state.grid.gridOptions.api)},
            suppressPropertyNamesCheck: true,
            suppressDragLeaveHidesColumns: true,
            columnDefs: columnDef,
            floatingFilter: true,
            rowSelection: 'multiple',
            rowModelType: 'serverSide',
            cacheBlockSize: 100,
            maxBlocksInCache: 500,
            maxConcurrentDatasourceRequests: 2,
            enableCellTextSelection: true,
            ensureDomOrder: true,
            animateRows: true,
            debug: false
        };

        const grid = new agGrid.Grid((this.refs.gridRef as HTMLElement), gridOptions);
        if (localStorage.getItem('cameFromInstance')) {
            localStorage.removeItem('cameFromInstance');
            this.restoreGridState(gridOptions)
        }
        gridOptions.api.setServerSideDatasource(this.ServerSideDatasource());
        this.setState({grid}, () => {
            Utils.$(".ag-floating-filter-input" ).each(function( index ) {
                Utils.$(this).attr('id', 'gl-search-filter-' + index);
            });
        });

        $("#hide-nav-btn").on("click", function () {
            setTimeout(() => {
                gridOptions.api.sizeColumnsToFit();
            }, 500);
        });
    };

    restoreGridState = (gridOptions: any) => {
        gridOptions.api.setSortModel(window['sortState']);
        gridOptions.api.setFilterModel(window['filterState']);
        if (window['filterState'] && window['filterState']['quickFilter']) {
            $(this.refs.quickFilterBox).val(window['filterState']['quickFilter'].filter)
        }
    };

    ServerSideDatasource() {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sort = AgGridUtils.generateSortData(params.request.sortModel);
                const filter = AgGridUtils.generateFilterData(params);
                Axios.instance.post(`boi/all?dataFormat=MAP&page=${page}&limit=${limit}`, {
                    filter: JSON.stringify(filter),
                    searchText: params.request.filterModel.quickFilter ? params.request.filterModel.quickFilter.filter : "",
                    sort: JSON.stringify(sort)
                })
                    .then((response: any) => {
                        if (this._isMounted) {
                            const dataArray = response.data.content.map(item => {
                                return {
                                    id: item.id,
                                    name: item.name,
                                    type: item.boClass,
                                    tags: item.tags,
                                    updated: Utils.moment(item.updated, Utils.moment.ISO_8601).isValid() ? Utils.utcToLocalDate(item.updated) : item.updated
                                }
                            });
                            try {
                                const lastRow = dataArray.length < limit ? params.request.startRow + dataArray.length : -1;
                                params.successCallback(dataArray, lastRow);
                                this.state.grid.gridOptions.selectAllHeader.update(response.data.totalElements, (limit * (page + 1)) > response.data.totalElements ? response.data.totalElements : (limit * (page + 1)), params.parentNode.gridApi.getSelectedRows().length);
                                if (this.state.grid.gridOptions.selectAllHeader.isSelected()) {
                                    this.state.grid.gridOptions.selectAllHeader.selectAll();
                                }
                                this.state.grid.gridOptions.api.sizeColumnsToFit();
                                this.forceUpdate();
                            } catch (e) {
                                console.error(e);
                            }
                        }
                    })
                    .catch((e) => {
                        AgGridUtils.serverSideErrorHandler(e)
                        params.failCallback();
                    })
            }
        }
    }

    onInput = (e) => {
        if (e.currentTarget.value === '' && !e.nativeEvent.inputType) {
            // 'X' button inside the input is pressed
            this.state.grid.gridOptions.api.setFilterModel({
                quickFilter: {
                    filterType: "text",
                    type: "contains",
                    filter: $(this.refs.quickFilterBox).val()
                }
            });
        }
    };

    render(): React.ReactNode {
        return (
            <div style={{width: "100%", height: "calc(100% - 40px)"}}>
                <div style={{height: 50, backgroundColor: "#2D3436", display: "flex"}} className="bo-core-header top-header">
                    <div style={{float: "left", paddingLeft: 2, width: "100%", display: "flex", alignItems: "center"}}>
                        <span id="globalSearchTitle" className="header-title">{this.props.title}</span>
                        <input ref={"quickFilterBox"} onKeyDown={this.onFilterTextBoxChanged.bind(this)} onInput={this.onInput}
                               placeholder="🔍 Global Search - Shift + UpArrow & Shift + DownArrow"
                               className="new-design"
                               tabIndex={1}
                               style={{width: "100%", height: 36, fontSize: 18, marginRight: 2}} type="search"
                        />
                        <div className="control-buttons">
                            <button onClick={this.onFilterTextBoxChanged.bind(this)}
                                    style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design">
                                <GlobalSearchHelpToolTip/>
                                <i className="fas fa-search"></i> Search
                            </button>
                            <button onClick={this.onDeleteHandler.bind(this)} style={{height: 36}}
                                    id={'delete-btn'}
                                    title={'CTRL + ALT + D'}
                                    className="btn btn-danger">
                                <i className="fas fa-trash-alt"></i> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>D</strong>elete
                            </button>
                        </div>
                    </div>
                </div>
                <div style={{width: "100%", height: "calc(100% - 35px)", padding: 10, backgroundColor: '#2D3436'}}>
                    <div ref={"gridRef"} className={"ag-theme-balham-dark ag-grids"}
                         style={{width: "100%", height: "100%"}}/>
                    <AgGridFooter
                        totalCount={this.state.grid ? this.state.grid.gridOptions.selectAllHeader.getState().totalItemsCount : 0}
                        loadedCount={this.state.grid ? this.state.grid.gridOptions.selectAllHeader.getState().loadedItemsCount : 0}
                        selectedCount={this.state.grid ? this.state.grid.gridOptions.selectAllHeader.getState().selectedItemsCount : 0}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        tagsSet: state.boCore.tagsSet,
        currentDataView: ownProps.currentDataView,
        currentBusinessObject: ownProps.currentBusinessObject,
        title: state.topHeader.title
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteInstances: (ids: number[], onSuccessCallback: any) => {
            dispatch(deleteInstances(ids, onSuccessCallback));
        },
        deleteBOInstanceTags: (currentInstance, originalInstance, tags) => {
            dispatch(deleteBOInstanceTags(currentInstance, originalInstance, tags));
        },
        addBOInstanceTags: (currentInstance, originalInstance, tags) => {
            dispatch(addBOInstanceTags(currentInstance, originalInstance, tags));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSearchGrid)



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/GlobalSearchGrid.tsx